import $ from 'jquery'
import Validator from './validator'
import { inputFilteringEvents, showValidationErrors } from '../util/form'
import validate from '../api/validation';
import { getOrder, updateOrder, getPaymentMethods, updateOrderItems } from '../api/checkout'
import assign from 'lodash/assign'
import Mustache from 'mustache'
import util from '../util'
import { getCart } from '../api/cart'
import getToken from '../api/token'
import { selectSavedDeliveryMethod } from './shipping'
import { updatePaymentMethods, initApplePay } from './payment'
import Promise from 'bluebird'
import Cookie from 'js-cookie';

const getValidator = ($form) => {
	const validator = new Validator($form)

	inputFilteringEvents($form)

	// validation success callback
	validator.on('success', $input => {
		$input.removeClass('validation-error').closest('.validation-error-msg').remove()
		$input.closest('.field').find('.validation-error-msg').remove()

	})

	// validation error callback
	validator.on('fail', ($input, errors) => {
		$input.addClass('validation-error')
		if (errors && errors.length) {
			showValidationErrors(validator.$form, errors)
		}
	})

	const pickupLocationChangeCallback = ($input, passed) => {
		const $shippingAddress = $input.closest('.shipping-address');
		const zipCode = $shippingAddress.find('#postnumber, #post_number').val();
		const city = $shippingAddress.find('#city').val();
		const address = $shippingAddress.find('#address').val();
		if (passed) {
			Cookie.set('checkout_postnumber', zipCode);
		}
		const $selected = $('.shipping-methods-list input[type="radio"]:checked');
		if ($selected.length) {
			const countryCode = $shippingAddress.find('#country').val();
			$('.shipping-methods-list').trigger('update-pickuplocations', [
				$selected.closest('dt').next('dd'),
				passed ? zipCode : null,
				passed ? city : null,
				passed ? address : null,
				countryCode
			])
		}
	};

	// update pickup locations on zip code, city & address inputs
	validator.addCallback('postnumber', pickupLocationChangeCallback);
	validator.addCallback('city', pickupLocationChangeCallback);
	validator.addCallback('address', pickupLocationChangeCallback);
	return validator
}

const updateSummary = ($container, data) => {

	if (!$container) { return false; }

	const templateId = $container.data('template');
	if (!templateId || !$container.find('.summary-container').length) { return false; }

	const template = $('#' + templateId).html()
	if (typeof template !== 'string') { return false; }

	data.renderPrice = () => (text, render) => parseFloat(render(text)).toFixed(2).replace('.',',') + ' &euro;';
	const markup = Mustache.render(template, data)
	$container.find('.summary-container').html(markup)
	$container.removeClass('editing')
	return true
}

const handleErrors = ($form, data = {}) => {
	if (data.errors && data.errors.length) {
		showValidationErrors($form, data.errors)
		const $scrollTarget = $form.find('.validation-alert:visible, .validation-error-msg:visible').first()
		const $offsetTarget = $scrollTarget.length ? $scrollTarget : $form
		$('html,body').animate({scrollTop: Math.max($offsetTarget.offset().top - 40, 0) })
		$form.trigger('error', [data.errors])
		return false
	}
	if (!data.pass) return false
	$form.trigger('pass')
	return true
}


export default async () => {
	const $container = $('.checkout-oneclick')
	if (!$container.length) return

	const orderId = $container.data('order-id');

	const templates = {
		payment: $('#mustache-checkout-oneclick-payment').html(),
		applepay: $('#mustache-applepay').html()
	};

	initApplePay();

	const showPaymentMethodsForm = ($section) => {
		const $loader = util.addFormLoader($section, { className: 'overlay' });
		return getCart()
			.then(({ cart }) => cart.totals.grandTotal)
			.then(orderTotal => getPaymentMethods({ orderTotal }))
			.then(async res => {
				const templateData = $.extend({}, res);
				templateData.paymentHtml = '<div class="payment-methods-container"></div>';
				templateData.editingPayment = true;
				const markup = Mustache.render(templates.payment, templateData);
				$container.find('.checkout-payment-methods').html(markup);
				updatePaymentMethods(res);
				$section.addClass('editing');
				await initApplePay();
				$loader.done();
				return res;
			});
	}

	$container.find('.checkout-payment-methods').on('edit', (e, data) => {
		showPaymentMethodsForm($(e.target), data);
	});

	// init form validation
	$container.find('.checkout-oneclick-form form').each(function() {
		const $form = $(this)
		const validator = getValidator($form)

		// validate fields on input change
		$(this).on('focusout', 'input', e => {
			const $input = $(e.currentTarget)
			validator.validateField($input)
		})

		$form.closest('.checkout-oneclick-form:not(.checkout-payment-methods)').on('update', function(e) {
			getOrder(orderId).then(res => {
				const $section = $(this)
				const definition = $section.find('form').data('definition');
				const data = { [definition]: res };
				if (definition === 'delivery') {
					$section.find('.shipping-methods-container').trigger('updateDeliveryMethods');
				}
				if (!$section.hasClass('editing')) {
					updateSummary($section, data)
				}
			})
		})
	})

	const submitForm = e => $(e.target).closest('form').submit()

	const $pickupLocator = $('.delivery-pickup-locator');

	if ($pickupLocator.find('select[name="pickuplocation"]').val()) {
		$pickupLocator.addClass('first-load');
	}

	$container
		.on('renderPickupLocations', '.delivery-pickup-locator', (e) => {
			if ($pickupLocator.hasClass('first-load')) {
				$pickupLocator.removeClass('first-load');
			} else {
				submitForm(e);
			}
		})
		.on('change', '.checkout-oneclick-form select[name="pickuplocation"]', submitForm)
		.on('change', '.checkout-oneclick-form input[name="deliverymethod"]:not(.has-pickuplocator)', submitForm)
		.on('click', '.edit-section', e => {
			e.preventDefault()
			const $section = $(e.target).closest('.checkout-oneclick-form')
			if ($section.hasClass('checkout-payment-methods')) {
				showPaymentMethodsForm($section)
			}
			else {
				$section.addClass('editing')
				if ($section.find('.shipping-methods-list').length) {
					selectSavedDeliveryMethod($section.find('.shipping-methods-list'));
				}
			}
		})
		.on('submit', '.checkout-oneclick-form .edit-form', e => {
			e.preventDefault()
			const $form = $(e.target)

			const plussaPrefix = '703240';

			const data = $form.serializeObject()

			if (data.kplussa_number) {
				// if kplussa_number doesn't start with plussaPrefix, add it
				if (data.kplussa_number.indexOf(plussaPrefix) !== 0) {
					data.kplussa_number = plussaPrefix + data.kplussa_number
				}
			}

			const definition = $form.data('definition') || 'order'

			if (data.deliverymethod) {
				const $input = $(`input[name="deliverymethod"][value="${data.deliverymethod}"]`)
				if (!$input.hasClass('has-pickuplocator')) {
					data.pickuplocation = ''
				}
			}
			if (definition !== 'delivery') {
				$form.addClass('loading');
			}
			updateOrder(orderId, data, definition)
				.then(res => {

					if (handleErrors($form, res) && res.order) {
						const update = {}
						update[definition] = res.order
						const $formContainer = $form.closest('.checkout-oneclick-form');
						if (definition === 'delivery') {
							const cartPromise = getCart(true, {
								orderId: orderId,
								applySaleCode: true
							})
							$container.find('.checkout-cart').trigger('cartaction', [cartPromise]);
							if (!$formContainer.hasClass('editing')) {
								updateSummary($formContainer, update)
								return true;
							}
						} else {
							updateSummary($formContainer, update)
							return true;
						}
						return false;
					}
				})
				.finally(() => {
					$form.removeClass('loading')
				}
				)
		})
		.on('click', '.continue', e => {
			e.preventDefault();
			const fields = {}
			const $btn = $(e.target);
			const $form = $btn.closest('form');

			$container.find('form').each((i, el) => assign(fields, $(el).serializeObject()));

			const $loader = util.addFormLoader($btn, {
				align: 'before',
				className: 'is-pulled-right'
			});

			const definition = $container.hasClass('skip-contact') ? 'blankOrder' : 'order';

			const formPromises = $container.find('.checkout-oneclick-form.editing:not(.checkout-payment-methods)')
				.map(function() {
					return new Promise((resolve, reject) => {
						if ($(this).find('input[type="submit"]').length) {
							$(this).find('input[type="submit"]').click()
							$(this)
								.one('pass', () => resolve(true))
								.one('error', (_, errors) => {
									const error = new Error('One click form validation failed')
									error.errors = errors
									reject(error)
								})
						} else {
							resolve(true);
						}
					})
				});

			if (fields.kplussa_number) {
				const plussaPrefix = '703240';

				if (fields.kplussa_number && fields.kplussa_number.indexOf(plussaPrefix) !== 0) {
					fields.kplussa_number = plussaPrefix + fields.kplussa_number
				}

			}

			Promise.all(formPromises.get()) // Submit any open forms first
				.then(() => validate({ definition, fields })) // Validation
				.then(res => {
					if (handleErrors($('.checkout-oneclick'), res)) {
						return getToken().then(async token => {

							$form.find('input[name="stage_token"]').val(token);
							const selectedPaymentMethod = $('input[name="stage-payment-provider"][type="hidden"]').val() || $('input[name="stage-payment-provider"]:checked').val();
							if (selectedPaymentMethod === 'ApplePay') {
								const applePay = await initApplePay();
								return updateOrderItems(orderId).then(order => {
									applePay.setOrder(order);
									applePay.openModal($('.continue'));
									$loader.done();
								});
							} else {
								return $form.trigger('submit');
							}
						})
					}
					else {
						return $loader.done()
					}
				})
				.catch(err => {
					let errors = err?.errors;
					if (!Array.isArray(errors) && Array.isArray(err)) {
						errors = err;
					}
					handleErrors($('.checkout-oneclick'), { errors: errors })
					return $loader.done()
				});
		});
}
